/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { MouvementStockDto } from '../models/mouvement-stock-dto';


/**
 * Fonctions de gestion des mouvements d'articles en stock
 */
@Injectable({
  providedIn: 'root',
})
export class MouvementStockService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation mouvementStockGetList
   */
  static readonly MouvementStockGetListPath = '/api/mouvement-stock/list/{stockId}';

  /**
   * Renvoie la liste des mouvements d'articles du stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mouvementStockGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  mouvementStockGetList$Response(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;
  }): Observable<StrictHttpResponse<Array<MouvementStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MouvementStockService.MouvementStockGetListPath, 'get');
    if (params) {
      rb.path('stockId', params.stockId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MouvementStockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des mouvements d'articles du stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `mouvementStockGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mouvementStockGetList(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;
  }): Observable<Array<MouvementStockDto>> {

    return this.mouvementStockGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MouvementStockDto>>) => r.body as Array<MouvementStockDto>)
    );
  }

  /**
   * Path part for operation mouvementStockLoadList
   */
  static readonly MouvementStockLoadListPath = '/api/mouvement-stock/load-list/{stockId}';

  /**
   * Renvoie la liste des mouvements d'articles du stock spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mouvementStockLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mouvementStockLoadList$Response(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, MouvementStockService.MouvementStockLoadListPath, 'post');
    if (params) {
      rb.path('stockId', params.stockId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des mouvements d'articles du stock spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `mouvementStockLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mouvementStockLoadList(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.mouvementStockLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation mouvementStockGet
   */
  static readonly MouvementStockGetPath = '/api/mouvement-stock/{id}';

  /**
   * Renvoie le mouvement d'article en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mouvementStockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  mouvementStockGet$Response(params: {

    /**
     * Identifiant du mouvement d&#x27;article en stock
     */
    id: number;
  }): Observable<StrictHttpResponse<MouvementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, MouvementStockService.MouvementStockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MouvementStockDto>;
      })
    );
  }

  /**
   * Renvoie le mouvement d'article en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `mouvementStockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mouvementStockGet(params: {

    /**
     * Identifiant du mouvement d&#x27;article en stock
     */
    id: number;
  }): Observable<MouvementStockDto> {

    return this.mouvementStockGet$Response(params).pipe(
      map((r: StrictHttpResponse<MouvementStockDto>) => r.body as MouvementStockDto)
    );
  }

  /**
   * Path part for operation mouvementStockPost
   */
  static readonly MouvementStockPostPath = '/api/mouvement-stock/{stockId}';

  /**
   * Crée le mouvement d'article pour un stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mouvementStockPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mouvementStockPost$Response(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;

    /**
     * Mouvement d'article en stock
     */
    body: MouvementStockDto
  }): Observable<StrictHttpResponse<MouvementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, MouvementStockService.MouvementStockPostPath, 'post');
    if (params) {
      rb.path('stockId', params.stockId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MouvementStockDto>;
      })
    );
  }

  /**
   * Crée le mouvement d'article pour un stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `mouvementStockPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mouvementStockPost(params: {

    /**
     * Identifiant du stock
     */
    stockId: number;

    /**
     * Mouvement d'article en stock
     */
    body: MouvementStockDto
  }): Observable<MouvementStockDto> {

    return this.mouvementStockPost$Response(params).pipe(
      map((r: StrictHttpResponse<MouvementStockDto>) => r.body as MouvementStockDto)
    );
  }

}
